/* Tab switching, payment-method visibility and small popup toggles.
 *
 * Extracted verbatim from src/App.script.js. Behaviour is unchanged;
 * these methods run on the App instance exactly as before.
 */
export default {
  methods: {

    hidePaymentMethod(slug) {
      if (!this.hiddenSlugs.includes(slug)) {
        this.hiddenSlugs.push(slug);
      }
    },
    // Function to remove a slug from the list of hidden slugs
    showPaymentMethod(slug) {
      this.hiddenSlugs = this.hiddenSlugs.filter(
        (hiddenSlug) => hiddenSlug !== slug
      );
    },

    showAdditionalFeesPopUp() {
      this.tdrAdditionalFeePopUp = true;
    },

    showCurrencyPopUp(){
      this.currencyRatePopUp = true;
    },

    hidecurrencyRatePopup(){
      this.currencyRatePopUp = false;
    },

    //later
    tabIndex(index) {
      window.localStorage.setItem("sp_active_tab", index);
    },

    active_tabs(index) {
      if (index == 1) {
        this.CheckLoginFunction();

        if (this.loginBool == 1 && this.is_card_on_file_active == 1) {
          this.SavedcardsAction();
          this.active_tab = "cards";
          this.cardSkeletonLoader = false;
        } else if (this.loginBool == 0 && this.is_card_on_file_active == 1) {
          this.show_cards(1);
          this.active_tab = "cards";
          this.cardSkeletonLoader = false;
        } else {
          this.show_cards(1);
          this.active_tab = "cards";
          this.cardSkeletonLoader = false;
        }
      } else if (index == 2) {
        this.active_tab = "mfs";
        this.cardSkeletonLoader = false;
        this.show_mbanking();
      } else if (index == 3) {
        this.active_tab = "ibanking";
        this.show_ibanking();
        this.cardSkeletonLoader = false;
      } else {
        this.active_tab = "cards";
        this.show_account();
        this.cardSkeletonLoader = false;
      }
    },

    //no need
    display_toc() {
      this.show_terms_conditions = true;
      this.toc_dialog = true;
    },
  },
};
